import { useState, useEffect } from 'react';
import api from '../lib/api';

export function useSubscription() {
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSubscription();
  }, []);

  const fetchSubscription = async () => {
    try {
      const response = await api.get('/auth/subscription');
      setSubscription(response.data);
    } catch (error) {
      console.error('Failed to fetch subscription:', error);
      setSubscription({
        has_access: false,
        status: 'expired',
        tier: null,
        days_remaining: 0,
        is_trial: false
      });
    } finally {
      setLoading(false);
    }
  };

  const hasAccess = subscription?.has_access || false;
  const isTrial = subscription?.is_trial || false;
  const daysRemaining = subscription?.days_remaining || 0;
  const tier = subscription?.tier;
  const status = subscription?.status;

  return {
    subscription,
    loading,
    hasAccess,
    isTrial,
    daysRemaining,
    tier,
    status,
    refresh: fetchSubscription
  };
}
